import React from "react";
import {createRoot} from "react-dom";
import "normalize.css";
import "./index.css";
import {Root} from "./screens/Root";

const container = document.getElementById("root");

createRoot(container).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
